module.exports = __webpack_public_path__ + "aaf99affc20fee2b11842eac72fb4386.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tsp-icon-circle-3.png
// module id = 1929
// module chunks = 0